import axios from "axios";
import {
    GET_WEEKLY_STAR_SETTINGS,
    UPDATE_WEEKLY_STAR_GIFTS,
    UPDATE_WEEKLY_STAR_REWARDS,
} from "./types";

const RANKS = ["first", "second", "third"];

// Settings come back with the reward items populated, so they are flattened back to ids
// before being sent again. Empty rank arrays are kept: they unset every reward of that rank.
const serializeRewards = (rewards = {}) =>
    RANKS.reduce((acc, rank) => {
        acc[rank] = (rewards[rank] || []).filter(Boolean).map((reward) => ({
            ...reward,
            item: reward?.item?._id || reward?.item,
        }));
        return acc;
    }, {});

export const getWeeklyStarSettings = () => (dispatch) => {
    axios
        .get("/weeklyStar/settings")
        .then((res) => {
            dispatch({ type: GET_WEEKLY_STAR_SETTINGS, payload: res.data.data });
        })
        .catch((error) => {
            console.log(error);
        });
};

export const updateWeeklyStarRewards = (rewards) => (dispatch) => {
    axios
        .post("/weeklyStar/rewards", { rewards: serializeRewards(rewards) })
        .then((res) => {
            dispatch({ type: UPDATE_WEEKLY_STAR_REWARDS, payload: res.data.data });
        })
        .catch((error) => {
            console.log(error);
        });
};

// `index` is the slot being edited; pass null to set a new eligible gift.
export const updateWeeklyStarGifts = (index, giftId) => (dispatch) => {
    axios
        .post("/weeklyStar/gifts", { index, giftId })
        .then((res) => {
            dispatch({ type: UPDATE_WEEKLY_STAR_GIFTS, payload: res.data.data });
        })
        .catch((error) => {
            console.log(error);
        });
};

export const removeWeeklyStarGift = (index) => (dispatch) => {
    axios
        .post("/weeklyStar/gifts/remove", { index })
        .then((res) => {
            dispatch({ type: UPDATE_WEEKLY_STAR_GIFTS, payload: res.data.data });
        })
        .catch((error) => {
            console.log(error);
        });
};
